import './LogViewer.css';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LazyLog } from 'react-lazylog';
import { Skeleton } from 'antd';
import { authenticationUtils } from '../../../utils/common';
import { logConfig } from '../../../config/env';

const LogViewer = props => {
    const [token, setToken] = useState();

    /** When: component mounted **/
    useEffect(() => {
        authenticationUtils.getUserToken().then(setToken);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ height: 700 }}>
            {token !== undefined ? (
                <LazyLog
                    fetchOptions={{
                        method: 'GET',
                        headers: {
                            Authorization: 'Bearer ' + token,
                            'access-control-allow-origin': '*',
                            'Content-Type': 'text/plain'
                        }
                    }}
                    stream
                    follow
                    extraLines={1}
                    enableSearch
                    selectableLines
                    caseInsensitive
                    url={logConfig.url}
                />
            ) : (
                <Skeleton paragraph={{ rows: 20 }} active />
            )}
        </div>
    );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogViewer);
